/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    makeAsyncReducer,
    asyncDefaults,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';
import { PassTypeDefaults } from '../props';

const fetchPassType = makeAsyncReducer(types.FETCH_PASS_TYPE);

const passType = mergeReducers(
    asyncDefaults(PassTypeDefaults),
    types.PP_PREFIX,
    fetchPassType
);

export default passType;

export const selectors = {
    getPassType: (state) => state.parkpass.passType.data,
};
